<link-button *ngIf="route == null && handler || skipHandler" (click)="handler && !disabled && handler()" [disabled]="disabled">
  <fa-icon [icon]="['fas', 'plus']"></fa-icon>
  {{ text }}
</link-button>
